// src/components/auth/AuthErrorPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { useMsal } from '@azure/msal-react';
import { useAuth } from '../../auth/AuthContext';

const AuthErrorPage = ({ message, redirectPath = '/' }) => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const { logout: contextLogout } = useAuth();
  
  const handleReturnHome = () => {
    // Clear all authentication data and state
    clearLocalAuthData();
    
    // Set flag to indicate we're manually navigating
    sessionStorage.setItem('manual_redirect', 'true');
    
    // Navigate to home page
    window.location.href = '/';
  };
  
  const clearLocalAuthData = () => {
    // Clear localStorage
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('activeEnvironment');
    localStorage.removeItem('registrationId');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('employeeNo');
    localStorage.removeItem('employeeId');
    localStorage.removeItem('clientCompanyId');
    localStorage.removeItem('clientCompanyName');
    localStorage.removeItem('clientCompanies');
    
    // Clear any other app-specific localStorage items
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('bc_') || key.includes('auth') || key.includes('user') || key.includes('token')) {
        localStorage.removeItem(key);
      }
    });
    
    // Clear sessionStorage (MSAL tokens)
    Object.keys(sessionStorage).forEach(key => {
      if (key.startsWith('msal.') || key.includes('token') || key.includes('auth')) {
        sessionStorage.removeItem(key);
      }
    });
    
    // Clear cookies related to authentication
    document.cookie.split(';').forEach(cookie => {
      const [name] = cookie.trim().split('=');
      if (name.includes('msal') || name.includes('auth') || name.includes('session')) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <div className="text-center mb-6">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <AlertCircle className="h-6 w-6 text-red-600" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900">Authentication Error</h2>
          <p className="mt-4 text-gray-600">{message || 'You do not have access to this application.'}</p>
        </div>
        <div className="mt-6">
          <div className="text-center">
            <button
              onClick={handleReturnHome}
              className="w-full inline-flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Return to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthErrorPage;